const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-shield-user preview-icon"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12 0c-.549 0-1.099.187-1.539.563l-.008.008C8.73 2.076 6.108 3.27 4.363 3.27c-1.192 0-2.182.99-2.182 2.182v7.637c0 2.982 1.092 5.358 2.79 7.096 1.692 1.733 3.931 2.862 6.294 3.68.468.173.982.182 1.455.021q.006 0 .01-.002c2.364-.824 4.607-1.96 6.302-3.699 1.695-1.74 2.787-4.114 2.787-7.096V5.451c0-1.192-.99-2.182-2.182-2.182-1.75 0-4.356-1.182-6.09-2.698l-.008-.008A2.36 2.36 0 0 0 12 0m-.121 2.223a.177.177 0 0 1 .242 0c2.084 1.818 4.906 3.228 7.516 3.228v7.637c0 2.473-.818 4.189-2.167 5.572-1.347 1.382-3.277 2.4-5.449 3.158l-.025-.008c-2.18-.753-4.117-1.77-5.466-3.152s-2.167-3.097-2.167-5.57V5.451c2.614 0 5.442-1.42 7.516-3.228"
    ></path>
  </svg>
);

export default SvgIcon;

